import { render } from "./HistoryJobDetails.vue?vue&type=template&id=0c67c65a"
import script from "./HistoryJobDetails.vue?vue&type=script&lang=js"
export * from "./HistoryJobDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__